import type { ReactNode, FormHTMLAttributes } from 'react';

export interface FormContainerProps extends FormHTMLAttributes<HTMLFormElement> {
  /** フォームのタイトル */
  title?: string;
  /** サブ見出し */
  subheading?: string;
  /** 子要素 */
  children: ReactNode;
  /** 追加のクラス名 */
  className?: string;
}

/**
 * AIPデザインシステムのフォームコンテナコンポーネント
 */
export const FormContainer: React.FC<FormContainerProps> = ({
  title,
  subheading,
  children,
  className = '',
  ...formProps
}) => {
  return (
    <form className={`aip-form-container ${className}`.trim()} {...formProps}>
      {(title || subheading) && (
        <div className="aip-form-container__header">
          {title && <h2 className="aip-form-container__title">{title}</h2>}
          {subheading && <p className="aip-form-container__subheading">{subheading}</p>}
        </div>
      )}
      <div className="aip-form-container__body">{children}</div>
    </form>
  );
};

export interface FormSectionProps {
  /** セクションタイトル */
  title?: string;
  /** セクションのサブ見出し */
  subheading?: string;
  /** レイアウト（horizontal: 横並び, vertical: 縦並び） */
  layout?: 'horizontal' | 'vertical';
  /** 子要素 */
  children: ReactNode;
  /** 追加のクラス名 */
  className?: string;
}

/**
 * フォームセクションコンポーネント
 */
export const FormSection: React.FC<FormSectionProps> = ({
  title,
  subheading,
  layout = 'horizontal',
  children,
  className = '',
}) => {
  const bodyClassName = layout === 'vertical'
    ? 'aip-form-container__section-body aip-form-container__section-body--vertical'
    : 'aip-form-container__section-body';

  return (
    <section className={`aip-form-container__section ${className}`.trim()}>
      {(title || subheading) && (
        <div className="aip-form-container__section-header">
          {title && <h3 className="aip-form-container__section-title">{title}</h3>}
          {subheading && (
            <p className="aip-form-container__section-subheading">{subheading}</p>
          )}
        </div>
      )}
      <div className={bodyClassName}>{children}</div>
    </section>
  );
};

export interface FormButtonsProps {
  /** 子要素（ボタン等） */
  children: ReactNode;
  /** 追加のクラス名 */
  className?: string;
}

/**
 * フォームボタンエリアコンポーネント
 */
export const FormButtons: React.FC<FormButtonsProps> = ({ children, className = '' }) => {
  return (
    <div className={`aip-form-container__buttons ${className}`.trim()}>{children}</div>
  );
};

export default FormContainer;

